import weatheroid from "../../../img/numberguess.png";
import "./Projectleftimage.css";

const Projectimage = () => {
  return <img src={weatheroid} className="photossss  reveal fade-left" />;
};

export default Projectimage;
